style= require('./card.styl')

- var obj = this.obj || {}

.card
  if obj[header]
    ft-clipboard.id
      span= obj[header]
      span.match-icon
        ft-icon(name=`ui--clipboard`)
  if obj.uid
    ft-clipboard.id
      span= obj.uid
      span.match-icon
        ft-icon(name=`ui--clipboard`)
  each key in (keys || Object.keys(obj))
    if obj[key] != null
      section
        label= translations[key] || key
        .value(pos= key === 'pos')= getValue(obj, key)
